// extracted by mini-css-extract-plugin
export default {"component":"EmployeeTable_component__rc-xn","tableContainer":"EmployeeTable_tableContainer__YHn2m","rowDiv":"EmployeeTable_rowDiv__sH+K8"};